import axiosCommon from '@/api/axiosCommon'
import axios from 'axios'

let active = {
    namespaced: true,
    state: {
        
    },
    // getters加工
    getters: {
        
    },
    //mutation 同步操作
    mutations: {
        
    },
    // action 异步操作
    actions: {
        // 申请激活码
        async getApplyActivationCode({ commit }, params){
            let result =  await axiosCommon.post("/rest/generateCode",params)
            if(result){
                
                return result
            }
        }
    }
}

export default active;